module.exports = "/packs/media/images/saving1-935d667805ef0896f90ef2c6b5448c49.jpg";